"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderHtml = void 0;
var React = require("react");
var answers_ui_libby_1 = require("@wix/answers-ui-libby");
var answers_experiments_1 = require("@wix/answers-experiments");
exports.RenderHtml = function (props) {
    if (answers_experiments_1.isFeatureEnabled('UseLibbyRenderHtmlInArticleViewer')) {
        return React.createElement(answers_ui_libby_1.RenderHtml, { html: props.html, className: props.className });
    }
    else {
        var html = { __html: props.html };
        return React.createElement("span", { dangerouslySetInnerHTML: html, className: props.className });
    }
};
//# sourceMappingURL=render-html.comp.js.map